
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airports/toplists",
      function () {
        return require("private-next-pages/airports/toplists.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airports/toplists"])
      });
    }
  